const $dragdrop = document.querySelector('.image-upload');
const $dragdroptxt = document.getElementById('dragdrop-txt');

if ($dragdrop) {
  $dragdrop.addEventListener('dragenter', function () {
    $dragdrop.classList.add('drag-state');
    $dragdroptxt.innerHTML = $dragdroptxt.getAttribute('ondrag');
  });
  $dragdrop.addEventListener('dragleave', function () {
    $dragdrop.classList.remove('drag-state');
    $dragdroptxt.innerHTML = $dragdroptxt.getAttribute('onneutral');
  });
}

function getUploadedImage(event) {
  //  Validate upload type and handle response
  var imageType = /image.*/;
  var header = document.getElementById('upload-modal-title');
  var intro = document.getElementById('image-search-text');
  var feedback = document.getElementsByClassName('image-feedback')[0];
  var $section_buttons = [].slice.call(document.querySelectorAll('.gender'));
  if (!event.target.files[0].type.match(imageType)) {
    feedback.innerHTML =
      'Are you sure you uploaded an image? We can only support files with an image filetype. <br> Please try again.';

    $section_buttons.forEach(b => (b.style.display = 'none'));
  } else if (event.target.files[0].size > 2621440) {
    feedback.innerHTML =
      'Oops, this file is too large. We can only handle file sizes up to 2.5MB. <br> Please try again.';
    $section_buttons.forEach(b => (b.style.display = 'none'));
  } else {
    var imagediv = document.getElementById('imageDiv');
    imagediv.className = 'imageDiv';
    var img = document.getElementById('img-output');
    img.className = 'grote-foto newImage';
    img.src = URL.createObjectURL(event.target.files[0]);
    img.alt = 'Your file';
    img.style =
      'margin-left:auto; margin-right:auto; display:block;width:70%; height:auto;';
    // feedback.innerHTML = "Almost ready to find some fair fashion in the style of your image!"
    intro.innerHTML = intro.getAttribute('content');
    header.innerHTML = header.getAttribute('step2');
    $section_buttons.forEach(b => (b.style.display = undefined));
    [].slice
      .call(document.querySelectorAll('.before-upload'))
      .forEach(e => (e.style.display = 'none'));
    [].slice
      .call(document.querySelectorAll('.after-upload'))
      .forEach(e => (e.style.display = 'block'));
    [].slice
      .call(document.querySelectorAll('.image-feedback'))
      .forEach(e => (e.style.display = 'none'));
  }

  var buttonImageSend = document.getElementById('sendImageButton');

  buttonImageSend.onclick = function () {
    document.getElementById('imageDiv').style.display = 'none';
    document.getElementById('sendImageButton').style.display = 'none';
    document.getElementById('show-loading').style.display = 'block';

    header.innerHTML = 'Searching...';
    intro.innerHTML =
      'For the perfect sustainable and ethically produced matched in the same style as the clothing in your image';
    // var image = document.getElementById('output');
    var imageType = /image.*/;
    if (!event.target.files[0].type.match(imageType)) return;

    var form = document.getElementById('image-search');
    var fileField = document.querySelector('input[type="file"]');
    form.append(fileField);
    form.submit();
  };
}

export { getUploadedImage };
